import {
  PopoverAnchor,
  PopoverArrow,
  PopoverContent,
  type PopoverContentProps,
  PopoverRoot,
  PopoverTrigger,
} from './popover';

/**
 * Popover Components
 * <Popover.Root>
 *   <Popover.Trigger>
 *     <Button>Open Popover</Button>
 *   </Popover.Trigger>
 *   <Popover.Content>
 *     <div>Popover content</div>
 *   </Popover.Content>
 * </Popover.Root>
 */

export namespace Popover {
  export type ContentProps = PopoverContentProps;

  export const Root = PopoverRoot;

  export const Trigger = PopoverTrigger;
  export const Anchor = PopoverAnchor;
  export const Arrow = PopoverArrow;
  export const Content = PopoverContent;
}
